// extracted by mini-css-extract-plugin
module.exports = {"sli":"Sli_sli__UOloJ","container":"Sli_container__JzM43"};